import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, KeyValuePair, VariableType } from '../../models';
import { IStoreService } from '../../services';
import { guidEmpty } from '../../common';
import { Unsubscribe } from 'redux';
import { StoreElement, Store } from '../../stateManagement';

class UnitSelectController implements angular.IComponentController {
    disabled: boolean;
    field: string;
    formController: angular.IFormController;
    isEmptyAllowed: boolean;
    isLoading: boolean;
    loadingMessage: string;
    model: string;
    properties: KeyValuePair<string, string>[];
    variableTypeGuid: string;

    private _hasLoaded: angular.IDeferred<void>;
    private _unsubscribe: Unsubscribe;
    private _variablesTypes: _.Dictionary<VariableType>;

    static $inject = ['$q', 'storeService'];

    constructor(
        private _$q: angular.IQService,
        private _storeService: IStoreService,
    ) {
        this._hasLoaded = this._$q.defer<void>();
    }

    $onInit() {
        if (!this.field) {
            this.field = 'unitProperty';
        }

        this._unsubscribe = this._storeService.register(
            store => this.initStore(store),
            [StoreElement.Variables]
        );
    }

    $onDestroy() {
        this._unsubscribe();
    }

    $onChanges(changes: angular.IOnChangesObject) {
        this.validateUnit(this.model);
        if (changes['variableTypeGuid']) {
            if (changes['variableTypeGuid'].currentValue) {
                this._hasLoaded.promise.then(() => {
                    this.setProperties();
                });
            }
            else {
                this.properties = [];
            }
        }
    }

    private setProperties() {
        const props = this.getUnits(this.variableTypeGuid);
        if (this.isEmptyAllowed) {
            props.unshift({ key: guidEmpty, value: '' });
        } else {
            const vt = this._variablesTypes[this.variableTypeGuid];
            if (vt && !this.model || props.map(p => p.key).indexOf(this.model) < 0) {
                this.model = vt.internalUnitGuid;
            }
        }
        this.properties = props;
        this.validateUnit(this.model);
    }

    change(): void {
        this.validateUnit(this.model);
    }

    private getUnits(variableTypeGuid: string): KeyValuePair<string, string>[] {
        const vt = this._variablesTypes[variableTypeGuid];
        return vt
            ? vt.unitCollection
                .map(u => { return { key: u.guid, value: u.name }; })
            : [];
    }

    private initStore(store: Store): void {
        this._variablesTypes = store.variablesTypes.dictionary;
        this._hasLoaded.resolve();
    }

    private validateUnit(unitGuid: string): boolean {
        const isValid = !!this.disabled
            || (!!this.properties && (this.properties.length === 0 || _.some(this.properties, p => p.key === unitGuid)))
            || (!this.isEmptyAllowed && !!unitGuid && unitGuid !== guidEmpty);
        this.formController[this.field]?.$setValidity('required', isValid);
        return isValid;
    }
}

export const wtUnitSelect: ComponentDefinition = {
    componentId: 'wtUnitSelect',
    controller: UnitSelectController,
    template: require('./unitSelect.component.html'),
    controllerAs: 'vm',
    bindings: {
        disabled: '=?',
        field: '@',
        formController: '<',
        isEmptyAllowed: '<?',
        model: '=',
        variableTypeGuid: '<'
    }
};
